import React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Paper } from '@mui/material';
import SendReqCherry from '../sendReq/sendReqCherry';
import CardContentWeb from './cardContent/cardContentWeb';
import './providerCard.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const ProviderCardWeb = ({ data, ...props }) => {
	const [open, setOpen] = React.useState(false);

	return (
		<>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				handleClose={() => setOpen(false)}
				TransitionComponent={Transition}
				fullScreen={window.innerWidth < 600 ? true : false}>
				<SendReqCherry
					handleClose={() => setOpen(false)}
					createRequest={props.createRequest}
					updateRequest={props.updateRequest}
					data={data}
					reqID={props.reqID}
				/>
			</Dialog>
			<Paper
				onClick={() => {
					props.openProfile();
					props.setProfileData(data);
					props.setProfileIndex(props.index);
				}}
				className='ProviderCardPaper'>
				{/* <CardContentMobile data={data} setOpen={setOpen} reqID={props.reqID} /> */}
				<CardContentWeb data={data} setOpen={setOpen} reqID={props.reqID} />{' '}
			</Paper>
		</>
	);
};

export default ProviderCardWeb;
